export const getAlgoliaApiId = (): string => {
  if (typeof process.env.GATSBY_ALGOLIA_APP_ID !== 'string' || process.env.GATSBY_ALGOLIA_APP_ID === '') {
    throw (new Error('The env variable GATSBY_ALGOLIA_APP_ID could not be found.'));
  }
  return process.env.GATSBY_ALGOLIA_APP_ID;
};

export const getAlgoliaReadApiKey = (): string => {
  if (typeof process.env.GATSBY_ALGOLIA_READ_API_KEY !== 'string' || process.env.GATSBY_ALGOLIA_READ_API_KEY === '') {
    throw (new Error('The env variable GATSBY_ALGOLIA_READ_API_KEY could not be found.'));
  }
  return process.env.GATSBY_ALGOLIA_READ_API_KEY;
};

export const getStore = (): string => {
  if (typeof process.env.GATSBY_STORE !== 'string' || process.env.GATSBY_STORE === '') {
    throw (new Error('The env variable GATSBY_STORE could not be found.'));
  }
  return process.env.GATSBY_STORE;
};

export const Environment = process.env.GATSBY_ACTIVE_ENV === 'production' ? 'prod' : 'staging';

export const storeEquals = (site: string): boolean => getStore() === site;
export const isSiteNl = () => storeEquals('drukwerkdeal-nl');
export const isSiteBe = () => storeEquals('printdeal-be');

export const PPAG_ALGOLIA_SETTINGS = {
  indexName: isSiteNl() ? 'prod_drukwerkdeal_ppag' : 'prod_printdeal_ppag',
  hitsPerPage: 12,
};

/**
 * Returns test category ID from URL params in staging, allowing filter page tests without real product setup.
 * Category ID is set in the url query param via Playwright tests only.
 */
export const getPlaywrightTestCategoryIdForPPAGFilter = (searchParams : URLSearchParams) => {
  const isStaging = process.env.GATSBY_ACTIVE_ENV === 'staging';
  const testCategoryIdForStaging = searchParams.get('categoryId');
  if (
    typeof window !== 'undefined'
    && testCategoryIdForStaging
    && isStaging
  ) {
    return testCategoryIdForStaging;
  }
  return null;
};
